import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  width: 100%;
  padding: 12px 16px;
  background: #111111;
`

export const List = styled.ul`
  display: flex;
  list-style: none;
`
export const Item = styled.li`
  font-size: 16px;
  margin-right: 6px;
  color: ${Color.gray100};

  &::after {
    content: "|";
    margin-left: 6px;
  }

  &:last-child::after {
    content: "";
    margin-left: 0px;
  }

  & a {
    color: ${Color.gray100};
  }
`
